import { render } from "./DialogComponentCampi.vue?vue&type=template&id=10abe292"
import script from "./DialogComponentCampi.vue?vue&type=script&lang=js"
export * from "./DialogComponentCampi.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__